/**
 * @description
 * Objeto applicationdefs
 */

import { Typefinders } from "./typefinders.model";

export class Applicationdefs {
    public id:number = null;
    public code:string = "";
    public description:string;
    public layout:string;
    public typefinders: Typefinders[] = [];

    constructor() {}
  
}